import React, { useState } from 'react';
import withAppState from '../mobx/withAppState';
import mapItemChoicesToPrices from '../lib/mapItemChoicesToPrices';
import SwipeableContainer from '../components/Swipeable';
import spicy from '../assets/img/Icons_16/Spicy.svg';
import extraSpicy from '../assets/img/Icons_16/extraSpicy.svg';
import glutenFree from '../assets/img/Icons_16/GF.svg';
import vegetarian from '../assets/img/Icons_16/Veg.svg';
import vegan from '../assets/img/Icons_16/Vegan.svg';
import { Steps } from '../lib/constants';

// let params = new URL(document.location.toString()).searchParams;
// let restaurantUrlId = params.get("restaurantId");

const MenuItemChoiceItems = ({
  uiTags = [],
  menuItemChoiceItems,
  itemChoiceItems,
  update,
  maximum,
  filterDiet,
  dietaryFilter,
  categoryIndex,
  allowChoiceFiltering,
  culture,
  activeStep
}) => {
  if (!menuItemChoiceItems) return null;

  return menuItemChoiceItems
    .filter(item => {
      if (!filterDiet) return true;
      for (let key in dietaryFilter) {
        if (dietaryFilter[key] === true) {
          if (allowChoiceFiltering && item.dietaryAndAllergens.includes(key) === false) return false;
        }
      }
      return true;
    })
    .map((menuItemChoiceItem, index) => {
      const { name, description, price, dietaryAndAllergens = [], uiTags = [] } = menuItemChoiceItem;
      const itemChoiceItem = itemChoiceItems.find(
        (i) => i.id == menuItemChoiceItem.id
      );
      let selected = itemChoiceItem.qty > 0;

      return (
        <div key={index} className="menu-item-selector">
          <div className="menu-item-selector-inner">
            <label className="menu-label">
              <div className="menu-label-description">
                <div className="menu-label-col">
                  <div className="menu-title">
                    <p>{name}</p>
                  </div>
                  {description && (
                    <div className="menu-description">
                      <p>{description}</p>
                    </div>
                  )}
                </div>
                <div className="menu-label-col">
                  {dietaryAndAllergens !== null || [] ? (
                    <div className="dietary-icons">
                      <div className="dietary-icons-inner">
                        {(name || []).indexOf('Peppers') !== -1 && (
                          <span
                            key={`dietary-${categoryIndex}-spicy-1`}
                            className={`diet-icon ${(name || []).indexOf('Hot Green Peppers') !== -1 ? 'spicy' : 'spicy-hot'}`}>
                          </span>
                        )}
                        {(uiTags || []).includes('Spicy 1') && (
                          <span key={`dietary-${categoryIndex}-spicy-1`} className={`diet-icon spicy`}>
                            <img src={spicy} alt="spicy" />
                          </span>)}
                        {(uiTags || []).includes('Spicy 2') && (
                          <span key={`dietary-${categoryIndex}-spicy-2`} className={`diet-icon spicy-hot`}>
                            <img src={extraSpicy} alt="extraSpicy" />
                          </span>)}
                        {dietaryAndAllergens && dietaryAndAllergens.includes('Vegetarian') && (
                          <span key="diet-icon-1" className={`diet-icon vegetarian`}>
                            <img src={vegetarian} alt="vegetarian" />
                          </span>
                        )}
                        {dietaryAndAllergens && dietaryAndAllergens.includes('Vegan') && (
                          <span key="diet-icon-2" className={`diet-icon vegan`}>
                            <img src={vegan} alt="" />
                          </span>
                        )}
                        {dietaryAndAllergens && dietaryAndAllergens.includes('Gluten-Free') && (
                          <span key="diet-icon-3" className={`diet-icon gluten-free`}>
                            <img src={glutenFree} alt="" />
                          </span>
                        )}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                 {(activeStep === Steps.PRE_ORDER && price !== 0) && (
                  <div className="menu-label-col">
                    <div className="menu-price">
                      <p>
                        {culture?.symbol}
                        {price.toFixed(2)}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </label>
          </div>
        </div>
      );
    });
};

const MenuItemChoice = ({
  name,
  menuItemChoiceItems,
  itemChoiceItems,
  update,
  index,
  maximum,
  allowCustomisation,
  dietaryFilter,
  filterDiet,
  allowChoiceFiltering,
  culture,
  activeStep
}) => {
  const result = [];

  if (itemChoiceItems.length > 1 && allowCustomisation) {
    result.push(
      <div key={index} className="item-customiser-container">
        <div className="item-customiser-inner">
          {name.toLowerCase() !== 'please choose' && <div className="section-item-title">
            <div className="section-item-title-inner">
              <h3>{name}</h3>
              {/* <p>Choose how hot you want it</p> */}
            </div>
          </div>}
          <div className="customiser-selector">
            <MenuItemChoiceItems
              menuItemChoiceItems={menuItemChoiceItems}
              itemChoiceItems={itemChoiceItems}
              update={update}
              culture={culture}
              maximum={maximum}
              dietaryFilter={dietaryFilter}
              filterDiet={filterDiet}
              allowChoiceFiltering={allowChoiceFiltering}
              activeStep={activeStep}
            />
          </div>
        </div>
      </div>
    );
  }

  menuItemChoiceItems.forEach((menuItemChoiceItem) => {
    const { id, menuItemChoices } = menuItemChoiceItem;
    const itemChoiceItem = itemChoiceItems.find((i) => i.id === id);
    if (!itemChoiceItem) return;
    const { qty, itemChoices } = itemChoiceItem;
    if (qty > 0) {
      result.push(
        <MenuItemChoices
          menuItemChoices={menuItemChoices}
          itemChoices={itemChoices}
          update={update}
          allowCustomisation={allowCustomisation}
          dietaryFilter={dietaryFilter}
          filterDiet={filterDiet}
          allowChoiceFiltering={allowChoiceFiltering}
          culture={culture}
          activeStep={activeStep}
        />
      );
    }
  });
  return result;
};

const MenuItemChoices = ({ menuItemChoices, itemChoices, update, dietaryFilter, filterDiet, culture, activeStep }) => {
  if (!menuItemChoices) return null;
  return menuItemChoices.map((menuItemChoice, index) => {
    const { name, menuItemChoiceItems, maximum, allowCustomisation, allowChoiceFiltering } = menuItemChoice;
    const { itemChoiceItems } = itemChoices[index];
    return (
      <MenuItemChoice
        name={name}
        culture={culture}
        menuItemChoiceItems={menuItemChoiceItems}
        itemChoiceItems={itemChoiceItems}
        update={update}
        index={index}
        maximum={maximum}
        allowCustomisation={allowCustomisation}
        dietaryFilter={dietaryFilter}
        filterDiet={filterDiet}
        allowChoiceFiltering={allowChoiceFiltering}
        activeStep={activeStep}
      />
    );
  });
};

const createItemChoiceItemObject = (menuItemChoiceItems) => {
  if (!menuItemChoiceItems) return null;

  let defaultQuantity = 0;
  if (menuItemChoiceItems.length === 1) defaultQuantity = 1;

  return menuItemChoiceItems.map((menuItemChoiceItem) => {
    const { id, menuItemChoices } = menuItemChoiceItem;
    const result = {
      id,
      qty: menuItemChoiceItem.isIncluded ? 1 : defaultQuantity,
      itemChoices: [],
    };
    result.itemChoices = createItemChoiceObject(menuItemChoices);
    return result;
  });
};

const areItemChoiceItemsValid = (itemChoiceItems, menuItemChoiceItems) => {
  if (!itemChoiceItems && !menuItemChoiceItems) return true;
  if (!itemChoiceItems || !menuItemChoiceItems) return false;

  return itemChoiceItems.every(itemChoiceItem => {
    const { id, itemChoices } = itemChoiceItem

    const menuItemChoiceItem = menuItemChoiceItems.find(i => i.id === id);
    if (!menuItemChoiceItem) return false;
    const { menuItemChoices } = menuItemChoiceItem

    return areItemChoicesValid(itemChoices, menuItemChoices);
  })
}

const areItemChoicesValid = (itemChoices, menuItemChoices) => {
  if (!itemChoices && !menuItemChoices) return true;
  if (!itemChoices || !menuItemChoices) return false;

  return itemChoices.every(itemChoice => {
    const { id, itemChoiceItems } = itemChoice

    const menuItemChoice = menuItemChoices.find(i => i.id === id);
    if (!menuItemChoice) return false;
    const { menuItemChoiceItems, minimum } = menuItemChoice;

    const validItemChoiceItems = itemChoiceItems.filter(item => item.qty >= minimum);
    if (validItemChoiceItems.length === 0) return false

    return areItemChoiceItemsValid(validItemChoiceItems, menuItemChoiceItems);
  })
}

const createItemChoiceObject = (menuItemChoices) => {
  if (!menuItemChoices) return null;
  return menuItemChoices.map((menuItemChoice) => {
    const { id, menuItemChoiceItems } = menuItemChoice;
    const result = {
      id,
      itemChoiceItems: [],
    };
    result.itemChoiceItems = createItemChoiceItemObject(menuItemChoiceItems);
    return result;
  });
};

const MenuItem = props => {
  const { item, dietaryFilter, filterDiet, backButtonHandler, slideUpModal, categoryType, culture, hasBasket } = props;
  if (item !== null) {
    var { name, image, descriptionInfo, dietaryAndAllergens, menuItemChoices, promotionalItemText, uiTags } = item;
  }
  const defaultItemChoices = createItemChoiceObject(menuItemChoices);
  const [itemChoices, setItemChoices] = useState(defaultItemChoices);
  const update = () => {
    setItemChoices([...itemChoices]);
  };


  const price = mapItemChoicesToPrices(itemChoices, menuItemChoices);
  const canOrder = areItemChoicesValid(itemChoices, menuItemChoices);

  return (
    <>
      <div className={`modal-slide-bg ${!!slideUpModal ? 'active' : ''}`} onClick={backButtonHandler}></div>
      <SwipeableContainer
        modalAriaTitle="menuItemTitle"
        modalAriaDescription="menuItemDescription"
        handleModalCancel={backButtonHandler} 
        slideUpModal={!!slideUpModal}>

        <div>
          {!!item && (
            <div className="modal-item-image-wrapper">
              <div
                className={`modal-item-image ${!!image.trim() == '' &&
                  categoryType
                    .toLowerCase()
                    .trim()
                    .replace(/["~!@#$%^&*\(\)_+=`{}\[\]\|\\:;'<>,.\/?"\- \t\r\n]+/g, '-')
                  }`}
                style={{ backgroundImage: `url(${item.image || require('../assets/img/generic.jpg')})`, backgroundSize: 'cover' }}>
                {uiTags.includes('New') || uiTags.includes('Popular') || uiTags.includes('It\'s Back!') ? <div className="tag">
                  {!!uiTags && uiTags.includes('New') && (
                    <span className="uitag-text new">New</span>
                  )}
                  {!!uiTags && uiTags.includes('Popular') && (
                    <span className="uitag-text popular">Popular</span>
                  )}
                  {!!uiTags && uiTags.includes('It\'s Back!') && (
                    <span className="uitag-text new">It's Back!</span>
                  )}
                </div> : null}
              </div>
            </div>
          )}
          <div className="modal-slide-up-content">
            <div className="modal-content-inner item-card no-padding ">
              <div className="item-card-contents">
                <div className="title-content-wrapper">
                  <div className="title-content name">{name !== null && <h3 id="menuItemTitle">{name}</h3>}</div>
                  {
                     (props.activeStep === Steps.PRE_ORDER) && 
                     (
                        <div className="title-content value">
                            {price !== 0 ? (
                              <>
                                {culture?.symbol}
                                {price.toFixed(2)}
                              </>
                            ) : (
                              <>
                                {culture?.symbol}
                                {item?.minPrice.toFixed(2)}
                              </>
                            )}
                        </div>                     
                     )
                 }
                </div>
                {dietaryAndAllergens !== null || [] ? (
                  <div className="dietary-icons">
                    {uiTags
                      ? uiTags.map(element => {
                        if (element.includes('Spicy')) {
                          let iconSrc = '';
                          const value = element.toLowerCase().replace(' ', '-');
                          if (value === 'spicy-1') {
                            iconSrc = spicy;
                          } else if (value === 'spicy-2') {
                            iconSrc = extraSpicy;
                          }
                          return <img src={iconSrc} alt={value} />;
                        }
                      })
                      : ''}
                    {dietaryAndAllergens
                      ? dietaryAndAllergens.map(element => {
                        const value = element.toLowerCase().replace(' ', '-');
                        let iconSrc = '';
                        if (value === 'gluten-free') {
                          iconSrc = glutenFree;
                        } else if (value === 'vegetarian') {
                          iconSrc = vegetarian;
                        } else if (value === 'vegan') {
                          iconSrc = vegan;
                        }
                        return (
                          <img src={iconSrc} alt={value} />
                        );
                      })
                      : ''}
                  </div>
                ) : (
                  ''
                )}

                {!!item && !!descriptionInfo.description ? (
                  <div className="item-card-description">
                    <div className={`item-card-description-inner ${promotionalItemText ? 'promotion' : 'description-border'}`}>
                      {item !== null && <p>{descriptionInfo.description}</p>}
                      {descriptionInfo.info !== '' && (
                        <p id="menuItemDescription" className="item-description-info">
                          {descriptionInfo.info}
                        </p>
                      )}
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {!!item && promotionalItemText && (
                  <div className="item-card-description promotion">
                    <div className="item-card-description-inner description-border">
                      <p>{promotionalItemText}</p>
                    </div>
                  </div>
                )}

              </div>

              <div className="item-card-contents item-list">
                <MenuItemChoices
                  hasBasket={hasBasket}
                  menuItemChoices={menuItemChoices}
                  // itemChoices={itemChoices}
                  culture={culture}
                  itemChoices={defaultItemChoices}
                  update={update}
                  dietaryFilter={dietaryFilter}
                  filterDiet={filterDiet}
                  descriptionInfo={descriptionInfo}
                  activeStep={props.activeStep}
                />

                {!!item && canOrder && (
                  <div className="item-button-container">
                    <div className="item-button-container-inner">
                      <button
                        className="menu-cta primary-cta"
                        onClick={() => props.addToBasket(item, itemChoices)}
                      >
                        Add to order {price.toFixed(2)}
                      </button>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </SwipeableContainer>
    </>
  );
};

export default withAppState(MenuItem, {
  mobXProps: ({ swipeable, activeStep}) => ({
    swipeable,
    activeStep
  }),
});